document.addEventListener("DOMContentLoaded", () => {
    const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
  
    dropdownToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const dropdownMenu = toggle.nextElementSibling;
        const dropdownIcon = toggle.querySelector(".dropdown-icon");
  
        // Toggle active state for menu visibility and icon rotation
        dropdownMenu.classList.toggle("active");
  
        // Rotate the icon
        if (dropdownMenu.classList.contains("active")) {
          dropdownIcon.style.transform = "rotate(-180deg)";
        } else {
          dropdownIcon.style.transform = "rotate(0deg)";
        }
  
        // Update aria-expanded for accessibility
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", !isExpanded);
      });
  
      // Optional: Add keyboard accessibility for Enter/Space keys
      toggle.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle.click();
        }
      });
    });
  });